import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from './styles.module.scss';
import { formatTime } from '@utils/utils';

const GroupNotesUpdatetime = () => {
    const { PricesInfo } = useSelector((state: RootState) => state.groupReducer);
    const modifyTime = formatTime(PricesInfo?.ModifySysDateTime || '');
    return (
        (PricesInfo && (
            <div className={styles.container}>
                更新時間：<span>{modifyTime}</span>
            </div>
        )) ||
        null
    );
};

export default GroupNotesUpdatetime;
